import rootStore from "@/app/store";
import crud, { ApiResponse } from "../crud";
import { Office } from "../offices";

export interface OfficeLocation {
  id: number;
  display_name: string;
  business_profile: number;
  address: string;
  city?: string;
  metro_station?: string;
  district?: string;
  floors_count: number;
  total_area: number;
  building_type: string;
  construction_year: number;
  cadastral_number: string;
  latitude: number;
  longitude: number;
  city_name?: string;
  city_display_name?: string;
}

export type LocationCreate = Omit<OfficeLocation, "id">;
export type LocationUpdate = Partial<LocationCreate>;

export interface BuildingType {
  name: string;
  display_name: string;
}

export interface City {
  name: string;
  display_name: string;
}

export function LocationsAPI(baseUrl: string) {
  return {
    list: async () => {
      const businessProfileId =
        rootStore.getState().businessProfile.businessProfile.id;
      return (await crud.get(
        `${baseUrl}/locations/?business_profile_id=${businessProfileId}`,
        undefined,
        true,
      )) as ApiResponse<OfficeLocation[]>;
    },
    get: async (id: number) => {
      const businessProfileId =
        rootStore.getState().businessProfile.businessProfile.id;
      return (await crud.get(
        `${baseUrl}/locations/${id}?business_profile_id=${businessProfileId}`,
        undefined,
        true,
      )) as ApiResponse<OfficeLocation>;
    },
    create: async (locationData: LocationCreate) => {
      const businessProfileId =
        rootStore.getState().businessProfile.businessProfile.id;
      return (await crud.post(
        `${baseUrl}/locations/?business_profile_id=${businessProfileId}`,
        locationData,
        true,
      )) as ApiResponse<OfficeLocation>;
    },
    update: async (id: number, locationData: LocationUpdate) => {
      const businessProfileId =
        rootStore.getState().businessProfile.businessProfile.id;
      return (await crud.put(
        `${baseUrl}/locations/${id}?business_profile_id=${businessProfileId}`,
        locationData,
        true,
      )) as ApiResponse<object>;
    },
    delete: async (id: number) => {
      const businessProfileId =
        rootStore.getState().businessProfile.businessProfile.id;
      return (await crud.delete(
        `${baseUrl}/locations/${id}?business_profile_id=${businessProfileId}`,
        true,
      )) as ApiResponse<object>;
    },
    getOfficesByLocation: async (id: number) => {
      const businessProfileId =
        rootStore.getState().businessProfile.businessProfile.id;
      return (await crud.get(
        `${baseUrl}/locations/${id}/offices?business_profile_id=${businessProfileId}`,
        undefined,
        true,
      )) as ApiResponse<Office[]>;
    },
    getBuildingTypes: async () => {
      const businessProfileId =
        rootStore.getState().businessProfile.businessProfile.id;
      return (await crud.get(
        `${baseUrl}/locations/building-type?business_profile_id=${businessProfileId}`,
        undefined,
        true,
      )) as ApiResponse<BuildingType[]>;
    },
    getAddresses: async (address: string) => {
      const businessProfileId =
        rootStore.getState().businessProfile.businessProfile.id;
      return (await crud.get(
        `${baseUrl}/locations/addresses?business_profile_id=${businessProfileId}&address=${address}`,
        undefined,
        true,
      )) as ApiResponse<string[]>;
    },
    listCities: async () => {
      const businessProfileId =
        rootStore.getState().businessProfile.businessProfile.id;
      return (await crud.get(
        `${baseUrl}/locations/cities?business_profile_id=${businessProfileId}`,
        undefined,
        true,
      )) as ApiResponse<City[]>;
    },
  };
}
